import Structor from "../util/structor_2"

export default class HydratedDate extends Structor {
  defineStruct() {
    return {
      dateString: null,
      cardStackId: null,
      unitStart: [],
      unitEnd: [],
      unitIds: [],
      isMoving: false,
      index: 0,
    }
  }
}
